// ══════════════════════════════════════════════════════
// PeptideVault v6.5 — Lab Comparison View (Build Note #17)
// Compare two lab dates/panels side by side.
// Only compares normalized like-for-like units.
// ══════════════════════════════════════════════════════

var _labCompareA = null
var _labCompareB = null

function setLabCompareA(panelId) { _labCompareA = panelId; render() }
function setLabCompareB(panelId) { _labCompareB = panelId; render() }
function clearLabCompare() { _labCompareA = null; _labCompareB = null; render() }

function renderLabComparisonTab() {
  var panels = (S.labResults || []).slice().sort(function(a, b) { return b.date.localeCompare(a.date) })

  if (panels.length < 2) {
    return '<div class="tab-content" style="animation:fadeIn .25s ease">' +
      '<div class="row" style="margin-bottom:16px"><h2 style="font-size:20px;font-weight:700">Lab Comparison</h2></div>' +
      '<div class="card"><div class="empty-state" style="padding:48px">' +
        '<div class="empty-icon">\uD83D\uDD0D</div>' +
        '<p>Need at least 2 lab panels to compare</p>' +
        '<span>Add more lab results to enable side-by-side comparison.</span>' +
      '</div></div></div>'
  }

  var panelA = _labCompareA ? panels.find(function(p) { return p.id === _labCompareA }) : null
  var panelB = _labCompareB ? panels.find(function(p) { return p.id === _labCompareB }) : null

  // Auto-select: default to two most recent if nothing selected
  if (!panelA && panels.length >= 2) { panelA = panels[1]; _labCompareA = panelA.id }
  if (!panelB && panels.length >= 1) { panelB = panels[0]; _labCompareB = panelB.id }

  return '<div class="tab-content" style="animation:fadeIn .25s ease">' +
    '<div class="row" style="margin-bottom:16px;flex-wrap:wrap;gap:8px;align-items:center">' +
      '<h2 style="font-size:20px;font-weight:700">Lab Comparison</h2>' +
      '<div class="spacer"></div>' +
      '<button class="btn btn-secondary btn-sm" onclick="clearLabCompare()">Reset</button>' +
    '</div>' +

    // Panel selectors
    '<div style="display:grid;grid-template-columns:1fr auto 1fr;gap:12px;align-items:end;margin-bottom:16px">' +
      '<div class="form-group">' +
        '<label style="font-size:12px;color:var(--text3)">Date A (Baseline)</label>' +
        '<select class="form-input" style="font-size:13px" onchange="setLabCompareA(this.value)">' +
          panels.map(function(p) {
            return '<option value="' + p.id + '"' + (_labCompareA === p.id ? ' selected' : '') + '>' + fmt(p.date) + ' \u2014 ' + esc(p.panelName) + ' (' + (p.markers || []).length + ' markers)</option>'
          }).join('') +
        '</select>' +
      '</div>' +
      '<div style="padding:6px;font-size:18px;color:var(--text4);text-align:center">vs</div>' +
      '<div class="form-group">' +
        '<label style="font-size:12px;color:var(--text3)">Date B (Follow-up)</label>' +
        '<select class="form-input" style="font-size:13px" onchange="setLabCompareB(this.value)">' +
          panels.map(function(p) {
            return '<option value="' + p.id + '"' + (_labCompareB === p.id ? ' selected' : '') + '>' + fmt(p.date) + ' \u2014 ' + esc(p.panelName) + ' (' + (p.markers || []).length + ' markers)</option>'
          }).join('') +
        '</select>' +
      '</div>' +
    '</div>' +

    // Comparison table
    (panelA && panelB ? renderComparisonTable(panelA, panelB) : '<div class="card" style="padding:24px;text-align:center;color:var(--text4)">Select two panels to compare</div>') +
  '</div>'
}

function renderComparisonTable(panelA, panelB) {
  // Build marker maps
  var markersA = {}
  ;(panelA.markers || []).forEach(function(m) {
    markersA[m.name.toLowerCase()] = m
  })
  var markersB = {}
  ;(panelB.markers || []).forEach(function(m) {
    markersB[m.name.toLowerCase()] = m
  })

  // Union of all marker names, preserving first-seen order
  var allNames = []
  var seen = {}
  ;(panelA.markers || []).forEach(function(m) {
    var key = m.name.toLowerCase()
    if (!seen[key]) { seen[key] = true; allNames.push(m.name) }
  })
  ;(panelB.markers || []).forEach(function(m) {
    var key = m.name.toLowerCase()
    if (!seen[key]) { seen[key] = true; allNames.push(m.name) }
  })

  if (allNames.length === 0) {
    return '<div class="card" style="padding:24px;text-align:center;color:var(--text4)">No markers to compare</div>'
  }

  var daysBetweenPanels = ''
  if (panelA.date && panelB.date) {
    var d = daysBetween(panelA.date, panelB.date)
    daysBetweenPanels = Math.abs(d) + ' days apart'
  }

  var rows = allNames.map(function(name) {
    var key = name.toLowerCase()
    var mA = markersA[key]
    var mB = markersB[key]

    var valA = mA ? +mA.value : null
    var valB = mB ? +mB.value : null
    var unitA = mA ? (mA.unit || '') : ''
    var unitB = mB ? (mB.unit || '') : ''

    // Only calculate delta for like-for-like units
    var sameUnit = unitA.toLowerCase() === unitB.toLowerCase()
    var canCompare = valA !== null && valB !== null && !isNaN(valA) && !isNaN(valB) && sameUnit
    var absDelta = canCompare ? (valB - valA) : null
    var pctDelta = canCompare && valA !== 0 ? ((valB - valA) / Math.abs(valA) * 100) : null

    // Reference range from either panel
    var refLow = mA ? (+mA.refLow || null) : (mB ? (+mB.refLow || null) : null)
    var refHigh = mA ? (+mA.refHigh || null) : (mB ? (+mB.refHigh || null) : null)

    // Direction color: neutral by default (no interpretation unless user defines)
    // We use simple up/down arrows and neutral colors
    var deltaColor = 'var(--text3)'
    var arrow = ''
    if (canCompare && absDelta !== null && absDelta !== 0) {
      arrow = absDelta > 0 ? '\u25B2' : '\u25BC'
    }

    return '<tr style="border-bottom:1px solid var(--border2)">' +
      '<td style="padding:8px 14px;font-weight:500">' + esc(name) + '</td>' +
      '<td style="padding:8px 14px;text-align:right;font-weight:600">' + (valA !== null ? valA : '\u2014') + ' <span style="font-size:11px;color:var(--text4)">' + esc(unitA) + '</span></td>' +
      '<td style="padding:8px 14px;text-align:right;font-weight:600">' + (valB !== null ? valB : '\u2014') + ' <span style="font-size:11px;color:var(--text4)">' + esc(unitB) + '</span></td>' +
      '<td style="padding:8px 14px;text-align:right;color:' + deltaColor + '">' +
        (canCompare && absDelta !== null ? arrow + ' ' + (absDelta > 0 ? '+' : '') + absDelta.toFixed(1) : (sameUnit ? '\u2014' : '<span style="font-size:10px;color:var(--amber)" title="Units differ \u2014 cannot calculate delta">\u26A0 diff units</span>')) +
      '</td>' +
      '<td style="padding:8px 14px;text-align:right;color:' + deltaColor + '">' +
        (pctDelta !== null ? (pctDelta > 0 ? '+' : '') + pctDelta.toFixed(1) + '%' : '\u2014') +
      '</td>' +
      '<td style="padding:8px 14px;text-align:right;color:var(--text4);font-size:11px">' +
        (refLow || refHigh ? (refLow || '') + '\u2013' + (refHigh || '') : '\u2014') +
      '</td>' +
    '</tr>'
  }).join('')

  return '<div class="card" style="padding:0;overflow:hidden">' +
    '<div style="padding:10px 14px;background:var(--bg3);border-bottom:1px solid var(--border2);display:flex;justify-content:space-between;align-items:center">' +
      '<span style="font-size:13px;font-weight:600">Side-by-Side Comparison</span>' +
      '<span style="font-size:12px;color:var(--text4)">' + daysBetweenPanels + '</span>' +
    '</div>' +
    '<table style="width:100%;border-collapse:collapse;font-size:13px">' +
      '<thead><tr style="border-bottom:1px solid var(--border)">' +
        '<th style="padding:8px 14px;text-align:left;font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Marker</th>' +
        '<th style="padding:8px 14px;text-align:right;font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Date A <div style="font-weight:400;font-size:10px">' + fmt(panelA.date) + '</div></th>' +
        '<th style="padding:8px 14px;text-align:right;font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Date B <div style="font-weight:400;font-size:10px">' + fmt(panelB.date) + '</div></th>' +
        '<th style="padding:8px 14px;text-align:right;font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Abs \u0394</th>' +
        '<th style="padding:8px 14px;text-align:right;font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">% \u0394</th>' +
        '<th style="padding:8px 14px;text-align:right;font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Ref Range</th>' +
      '</tr></thead>' +
      '<tbody>' + rows + '</tbody>' +
    '</table>' +

    // Summary footer
    '<div style="padding:10px 14px;background:var(--bg3);border-top:1px solid var(--border2);font-size:12px;color:var(--text3)">' +
      '\u2139\uFE0F Direction colors are neutral \u2014 marker interpretation varies by clinical context. Values with different units show both readings without calculating a delta.' +
    '</div>' +
  '</div>'
}

export {
  _labCompareA,
  _labCompareB,
  setLabCompareA,
  setLabCompareB,
  clearLabCompare,
  renderLabComparisonTab,
  renderComparisonTable
}
